import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Table, Icon, Modal, InputNumber, Input } from 'antd';

import Page from '../../shared/components/Page';

import { serverLoadJobsSummary, serverPatchJobPriority } from '../actions';

const Search = Input.Search;

function sortByPriorityAndName(a, b) {
    if (a.priority === b.priority) {
        const aOrgName = a.organizationName.toUpperCase();
        const bOrgName = b.organizationName.toUpperCase();
        if (aOrgName < bOrgName) {
            return -1;
        } else if (aOrgName > bOrgName) {
            return 1;
        } else {
            return 0;
        }
    } else {
        return b.priority - a.priority;
    }
}

class JobsList extends Component {
    constructor(props) {
        super(props);

        const self = this;

        this.state = {
            editPriority: false,
            currentJob: null,
            updatedPriority: 1,
            searchTerm: '',
        }

        const EditPriorityColumn = (text, record) => (
            <div>
                {text}
                <a href="" onClick={(e) => {
                    self.setState({
                        editPriority: true,
                        currentJob: record,
                        updatedPriority: record.priority,
                    });
                    e.preventDefault();
                }}><Icon type="edit" /></a>
            </div>
        );

        this.columns = [{
                title: 'Organization',
                dataIndex: 'organizationName',
                key: 'organizationName'
            },{
                title: 'Country',
                dataIndex: 'country',
                key: 'country',
                filters: [
                    { text: 'New Zealand', value: 'NZ' },
                    { text: 'Australia', value: 'AU' },
                    { text: 'Singapore', value: 'SG' },
                ],
                onFilter: (value, record) => record.country === value,
            },{
                title: 'Task',
                dataIndex: 'task',
                key: 'task',
                filters: [
                    { text: 'POI Organization', value: 'validationPOIOrganization' },
                    { text: 'POI Center', value: 'validationFixPOICenter' },
                    { text: 'On-Premise', value: 'validationFixOnPremise' },
                ],
                onFilter: (value, record) => {
                    return record.task === value;
                }
            },{
                title: 'Priority',
                dataIndex: 'priority',
                key: 'priority',
                editable: true,
                render: EditPriorityColumn,
            },{
                title: 'Progress',
                dataIndex: 'progress',
                key: 'progress',
            },/*{
                title: 'Completed',
                dataIndex: 'completed',
                key: 'completed',
                filters: [
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ],
                onFilter: (value, record) => record.completed === value,
            },*/
        ];
    }
    componentDidMount() {
        this.props.loadJobsSummary();
    }

    priorityEditOk() {
        this.props.patchJobPriority(this.state.currentJob.jobId, this.state.updatedPriority);
        this.setState({
            editPriority: false,
            currentJob:null
        });
    }
    priorityEditCancel() {
        this.setState({
            editPriority: false,
            currentJob:null
        });
    }

    onSearchTermUpdate(value) {
        this.setState({
            searchTerm: value,
        });
    }

    render() {
        const { props } = this;

        const regexSearchTerm = new RegExp(this.state.searchTerm, 'ig');

        const jobsList = props.jobsList.filter(job => job.organization.name.match(regexSearchTerm)).map((job) => {
            return {
                key: job._id,
                jobId: job._id,
                organizationName: job.organization.name,
                country: job.organization.country,
                //createdAt: new Date(job.createdAt).toTimeString(),
                updatedAt: new Date(job.updatedAt).toISOString(),
                task: job.task,
                completed: job.completed ? 'Yes' : 'No',
                priority: job.priority,
                progress: `${job.summary.complete}/${job.summary.total}`,
            }
        });

        jobsList.sort(sortByPriorityAndName);

        return (
            <Page>
                <Page.MainArea>
                    <div className="container-with-padding">
                        <h4 className="heading-level-1" style={{
                            marginBottom: 16,
                        }}>Jobs Summary</h4>
                        <Search
                            placeholder="Search for Organizations"
                            onSearch={this.onSearchTermUpdate.bind(this)}
                            style={{ marginBottom: 16 }}
                        />
                        {this.state.currentJob !== null ? (
                            <Modal
                                title={`Update the priority for ${this.state.currentJob.organizationName}(${this.state.currentJob.country}) - ${this.state.currentJob.task}`}
                                visible={this.state.editPriority}
                                onOk={this.priorityEditOk.bind(this)}
                                onCancel={this.priorityEditCancel.bind(this)}>
                                <InputNumber min={1} value={this.state.updatedPriority} onChange={(value) => {
                                    this.setState({
                                        updatedPriority: value,
                                    });
                                }} />
                            </Modal>
                        ) : null}

                        <Table
                            columns={this.columns}
                            dataSource={jobsList}
                            pagination={{ pageSize: 15 }} />
                    </div>
                </Page.MainArea>
            </Page>
        )
    }
}

JobsList.propTypes = {
    loadJobsSummary: PropTypes.func,
    patchJobPriority: PropTypes.func,
    jobsList: PropTypes.array,
}

// Map props to the store

const mapStateToProps = (state) => ({
    jobsList: state.routes.admin.get('jobsList'),
});

const mapDispatchToProps = (dispatch) => ({
    loadJobsSummary: () => {
        dispatch(serverLoadJobsSummary());
    },
    patchJobPriority: (jobsId, priority) => {
        dispatch(serverPatchJobPriority(jobsId, priority));
    }
});

const JobsListContainer = connect(mapStateToProps, mapDispatchToProps)(JobsList);

export default JobsListContainer;



// WEBPACK FOOTER //
// ./src/admin/pages/JobsSummary.js